import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/main.css'
import { initAnalytics, trackPageView } from './utils/analytics'
import { registerAppServiceWorker } from './utils/pushNotifications'

Vue.config.productionTip = false

initAnalytics()
registerAppServiceWorker().catch(() => undefined)

router.afterEach((to) => {
  trackPageView(to)
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
